<template>
    <div v-loading="$parentInfo.studentCart.dialog_ChooseCoupon.loading">
        <div>
            <el-form label-width="90px" :label-position="'right'">
                <el-row :gutter="10">
                    <el-form-item label="优惠券:">
                        <el-select v-model="$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids" placeholder="请选择"
                                   multiple>
                            <el-option
                                    v-for="item in $parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons"
                                    :key="item.id"
                                    :label="item.money"
                                    :value="item.id"
                                    :disabled="item.status">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row :gutter="10">
                    <el-form-item label="课程总价:">
                        <div>{{$store.state.modal.data.sum_price}}</div>
                    </el-form-item>
                </el-row>
                <el-row :gutter="20">
                    <el-form-item label="抵扣:">
                        <div>{{deduction}}</div>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" size="small" @click="handleStoreCartCoupon()"
                       :loading="$parentInfo.studentCart.dialog_ChooseCoupon.button_loading">确 定
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_ChooseCoupon',
        data() {
            return {
            };
        },
        mounted() {
        },
        computed: {
            deduction: function () {
                let vm = this;
                let sum = 0;
                let status = 'false';
                if (vm.$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids.length !== 0) {
                    for (let i in vm.$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids) {
                        if(vm.$parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons[vm.$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids[i]]){
                            sum += vm.$parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons[vm.$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids[i]].money;
                        }

                        if (sum > vm.$store.state.modal.data.sum_price) {
                            sum = vm.$store.state.modal.data.sum_price;
                            status = 'true'
                        }
                    }
                    if (vm.$parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons !== 0) {
                        for (let j in vm.$parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons) {
                            vm.$parentInfo.studentCart.dialog_ChooseCoupon.studentCoupons[j].status = status;
                        }
                    }
                }
                return sum;
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleMessage();
        },
        methods: {
            handleMessage() {
                this.$wApi.send(this.$parentInfo.path, 'chooseCoupon', {
                    'studentCart_id': this.$store.state.modal.data.cart_id,
                });
            },
            handleStoreCartCoupon() {
                this.$parentInfo.studentCart.dialog_ChooseCoupon.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'storeCartCoupon', {
                    'coupon_ids': this.$parentInfo.studentCart.dialog_ChooseCoupon.coupon_ids,
                    'studentCart_id': this.$store.state.modal.data.cart_id,
                });
            },
        }
    };
</script>

<style scoped>
</style>
